import { render, staticRenderFns } from "./resgatarPontos.vue?vue&type=template&id=4d7b6276"
import script from "./resgatarPontos.ts?vue&type=script&lang=js&external"
export * from "./resgatarPontos.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d7b6276')) {
      api.createRecord('4d7b6276', component.options)
    } else {
      api.reload('4d7b6276', component.options)
    }
    module.hot.accept("./resgatarPontos.vue?vue&type=template&id=4d7b6276", function () {
      api.rerender('4d7b6276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/cliente/resgatarPontos.vue"
export default component.exports